import React from 'react';
import PropTypes from 'prop-types';
import { AmplifyGrid, AmplifyGridRow } from '@amplify/amplify-grid';
import Spinner from '../../spinner/Spinner';
import { gridProps as defaultGridProps } from './resultsHelper';
import { generateReactKey } from '../../../utils/shared/commonUtils';
import { createDataTourStep } from '../../../utils/shared/demoModeUtils';

const ResultsTable = ({ areResultsUpdating, tableId, toolTipElId, sortBy, rows, gridProps }) => (
    <>
        {areResultsUpdating ? (
            <Spinner />
        ) : (
            <div
                id={tableId}
                key={toolTipElId} // Force re-render on toggling demoMode on
                className="grid-window-wrapper"
                data-tour-step={createDataTourStep(toolTipElId)}
            >
                <AmplifyGrid key={tableId} {...gridProps} sortBy={sortBy}>
                    {rows.map((row, index) => (
                        <AmplifyGridRow
                            key={generateReactKey(index)}
                            {...row.rowProperties}
                            rowObject={row.rowObject}
                        />
                    ))}
                </AmplifyGrid>
            </div>
        )}
    </>
);

ResultsTable.defaultProps = {
    areResultsUpdating: false,
    tableId: '',
    sortBy: {},
    rows: [
        {
            rowProperties: {},
            rowObject: {},
        },
    ],
    gridProps: defaultGridProps,
    toolTipElId: '',
};

ResultsTable.propTypes = {
    areResultsUpdating: PropTypes.bool,
    tableId: PropTypes.string,
    sortBy: PropTypes.object,
    rows: PropTypes.array,
    gridProps: PropTypes.object,
    toolTipElId: PropTypes.string,
};

export default ResultsTable;
